import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Carousel } from "@domain/carousel/carousel";
import { Secondary } from "@ui/components/containers/textBlocks";
import { InfiniteScroll } from "@ui/components/infiniteScroll";
import { CarouselThumbnail } from "@ui/components/pdfCarousel/carouselThumbnail";
import { desktop, gap, mobile } from "@ui/styles/utils";

interface FavoriteCarouselsListProps extends React.HTMLAttributes<HTMLDivElement> {
	totalElements: number | undefined;
	carousels: Carousel[];
	loading: boolean;
	moreLoading: boolean;
	fetchMore: () => Promise<void>;
}

export const FavoriteCarouselsList: React.FC<FavoriteCarouselsListProps> = ({
	totalElements = 0,
	carousels,
	loading,
	moreLoading,
	fetchMore,
	...htmlProps
}) => {
	if (totalElements === 0) {
		return <Secondary>{I18n.t("profile.favorite.empty")}</Secondary>;
	}
	return (
		<InfiniteScroll onEndReached={fetchMore} loading={loading || moreLoading}>
			<Carousels {...htmlProps}>
				{carousels.map((carousel) => (
					<CarouselThumbnail key={carousel.id} carousel={carousel} />
				))}
				{loading && <ClipLoader />}
			</Carousels>
		</InfiniteScroll>
	);
};

const Carousels = styled.div`
	@media ${desktop} {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap: 20px;
	}
	@media ${mobile} {
		${gap(20)};
	}
`;
